module.exports = __webpack_public_path__ + "static/img/verify-envelope.53f9afe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verify-envelope.svg
// module id = 3028
// module chunks = 1